import React from 'react';

const HomePage: React.FC = () => {
  return (
    <h1 className="title">Home page</h1>
  );
};

export default HomePage;
